export default class OpenCookie {
  constructor() {
    this.cookieOpen = document.querySelector("[data-open-cookie-settings]");

    this.cookieOpen.addEventListener("click", () => {
      CookieConsent.show();
    });
  }
}
